export default {
      id: "close-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#close-usage",
      toString: function () {
        return this.url;
      }
    }